import { Outlet } from 'react-router-dom';

import { ProtectedRoute } from '@/components/auth';

export function PrivateLayout() {
  return (
    <ProtectedRoute
      requiredRoles={['tenant-owner', 'tenant-user', 'tenant']}
      showRoleInfo
    >
      <Outlet />
    </ProtectedRoute>
  );
}
